import {Drawer} from 'theme';

var FavoritesDrawer = class extends Drawer {
  get shouldAppendToBody() {
    return true;
  }

  get openFrom() {
    return window.matchMedia(
        `${ window.themeVariables.breakpoints['sm-max'] }`).matches
        ? 'top'
        : this.getAttribute('open-from') || 'right';
  }
};

if (!window.customElements.get('favorites-drawer')) {
  window.customElements.define('favorites-drawer', FavoritesDrawer);
}

class MaisonCartListener {
  constructor() {
    this.updateCart();

    document.addEventListener('cart:change', () => {
      this.updateCart();
    });
  }

  async getCart() {
    return fetch('/cart.js').then(response => response.json());
  }

  isCartPage() {
    return document.querySelector('form[action="/cart"]') !== null;
  }

  async updateCart(data) {
    return this.getCart().then(this.updateCartItems.bind(this));
  }

  async updateCartItems(data) {
    let items = data.items;
    let updates = {};

    for (let i in items) {
      let item = items[i];

      // Delete children if parent item is deleted ...
      if (item.properties._bundle_product === true) {
        let parentItem = items.find(
            item2 => item2.properties._bundle_product !== true &&
                item2.properties._bundle_id &&
                item2.properties._bundle_id === item.properties._bundle_id);

        if (!parentItem) {
          updates[item.key] = 0;
        }
      }
    }

    if (updates) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({updates}),
      });

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (this.isCartPage()) {
        // TODO: Refresh cart page cart ...
      }
    }
  }

}

window.maisonCartListener = new MaisonCartListener();

